'use client';

import { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { SplineViewer } from 'components/shared/SplineViewer/SplineViewer';
import {
  powerplugsDesktopSrc,
  powerplugsMobileSrc,
} from 'components/shared/SplineViewer/scenes';
import styles from './Layout.module.css';

export const Layout = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => {
  const t = useTranslations('common');

  const handleContact = () => {
    if (typeof window !== 'undefined') {
      window.open('mailto:support@ultrahuman.com?', '_blank');
    }
  };

  return (
    <div className={className ? `${styles.root} ${className}` : styles.root}>
      <div className={styles.splineContainer} aria-hidden="true">
        <SplineViewer
          desktopSrc={powerplugsDesktopSrc}
          mobileSrc={powerplugsMobileSrc}
        />
      </div>

      <div className={styles.contentShell}>
        <div className={styles.content}>{children}</div>
        <div className={styles.footer}>
          <p>
            {t('form.support.anyIssues')}{' '}
            <button type="button" onClick={handleContact}>
              {t('form.support.emailSupport')}
            </button>{' '}
            {t('form.support.atEmail')}
          </p>
        </div>
      </div>
    </div>
  );
};
